import { MAX_PARTY_SIZE } from '../constants';

// party size as a headcount for wait-time estimates and training data: some
// accounts repurpose the size field, so implausible values count as 1 guest
export function normalizePartySize(size: number | string | null | undefined): number {
  const headcount = Number(size);

  return Number.isInteger(headcount) && headcount >= 1 && headcount <= MAX_PARTY_SIZE
    ? headcount
    : 1;
}
